import { render, staticRenderFns } from "./VideoGalleryItemComp.vue?vue&type=template&id=390355c8&scoped=true&"
import script from "./VideoGalleryItemComp.vue?vue&type=script&lang=ts&"
export * from "./VideoGalleryItemComp.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGalleryItemComp.vue?vue&type=style&index=0&id=390355c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390355c8",
  null
  
)

export default component.exports